<template>
  <FairHomeV2Page />
</template>

<script setup lang="ts">
import { FairHomeV2Page } from '@/widgets/home/fair-v2'
</script>
